// extracted by mini-css-extract-plugin
export var borderRadius = "_6r-4";
export var large = "_6r-3";
export var logoContainer = "_6r-0";
export var nameLogo = "_6r-2";
export var small = "_6r-1";